import { render, staticRenderFns } from "./UserEvents.vue?vue&type=template&id=13112db5&scoped=true"
import script from "./UserEvents.vue?vue&type=script&lang=js"
export * from "./UserEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13112db5",
  null
  
)

export default component.exports